import {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
} from "react";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import { useSearchParams } from "react-router-dom";

const RoiPersonalWatchContext = createContext();

const RoiPersonalWatchProvider = ({ children }) => {
  const [isAddModal, setIsAddModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isStocksModal, setIsStocksModal] = useState(false);
  const [selectedWatch, setSelectedWatch] = useState({ id: "", name: "" });

  const [searchParams] = useSearchParams();
  const query = searchParams.get("query")?.toLowerCase() || "";

  const fetcher = useCallback(
    () => fetchData("/favorite/favorite-roi-groups"),
    []
  );

  const {
    data: watches = [],
    isLoading: isLoadingWatches,
    isValidating: isValidatingWatches,
  } = useSWR("/favorite/favorite-roi-groups", fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 6000,
  });

  const filteredWatches = useMemo(() => {
    if (!query) return watches;
    return watches.filter((data) =>
      data.industrial_group_name.toLowerCase().includes(query)
    );
  }, [query, watches]);

  const value = useMemo(
    () => ({
      watches,
      filteredWatches,
      isLoadingWatches,
      isValidatingWatches,
      isAddModal,
      setIsAddModal,
      isDeleteModal,
      setIsDeleteModal,
      isStocksModal,
      setIsStocksModal,
      selectedWatch,
      setSelectedWatch,
    }),
    [
      watches,
      filteredWatches,
      isLoadingWatches,
      isValidatingWatches,
      isAddModal,
      isDeleteModal,
      isStocksModal,
      selectedWatch,
    ]
  );

  return (
    <RoiPersonalWatchContext.Provider value={value}>
      {children}
    </RoiPersonalWatchContext.Provider>
  );
};

export default RoiPersonalWatchProvider;

export const useRoiPersonalWatchContext = () =>
  useContext(RoiPersonalWatchContext);
